import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedActiveIssuesFilterComponent } from './shared-active-issues-filter.component';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { WithTooltipModule } from '../../with-tooltip/with-tooltip.module';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader } from '@ngx-translate/core';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../../assets/i18n/', '.json');
}

@NgModule({
  declarations: [SharedActiveIssuesFilterComponent],
  imports: [CommonModule, SharedLayoutModule, MatTooltipModule, WithTooltipModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class SharedActiveIssuesFilterModule {}
